/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const topSwiper = () => {
		// スライドの枚数を取得
		const slides = document.querySelectorAll('.top-mainVis .splide__slide');
		const slideCount = slides.length;
		
		const splide = new Splide('.top-mainVis.splide', {
			type: slideCount > 1 ? 'loop' : 'slide',
			perPage: 1,
			autoplay: slideCount > 1,
			interval: 5000,
			speed: 500,
			arrows: false,
			pagination: slideCount > 1,
			paginationKeyboard: slideCount > 1,
			drag: slideCount > 1,
			swipe: slideCount > 1,
		}).mount();

		// テキストがあるスライドにhas-textクラスを追加
		const addTextOverlayClass = () => {
			const slides = document.querySelectorAll('.top-mainVis .__item');
			slides.forEach(slide => {
				const txtWrap = slide.querySelector('.__txtWrap');
				if (txtWrap) {
					slide.classList.add('has-text');
				}
			});
		};

		addTextOverlayClass();

	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const topFUNCTIONS = () => {
		topSwiper();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { topFUNCTIONS(); }) : topFUNCTIONS();

})(window.FUNCTIONS);
